import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    account: {},
    question: {},
    answer: {},
    questiondetails: {},
    answerdetails: {},
    coinDetail: {},
  },
  reducers: {
    setAccount: (state, action) => {
      state.account = action.payload;
    },
    setQuestion: (state, action) => {
      state.question = action.payload;
    },
    setQuestionDetails: (state, action) => {
      state.questiondetails = action.payload;
    },
    setAnserDetails: (state, action) => {
      state.answerdetails = action.payload;
    },
    setHeader: (state, action) => {
      state.headerData = action.payload;
    },
    setAnswer: (state, action) => {
      state.answer = action.payload;
    },
    setCoinDetail: (state, action) => {
      console.log("🚀 ~ action:", action)
      state.coinDetail = action.payload;
    },
  },
});

// Export actions for dispatching
export const {
  setAccount,
  setHeader,
  setAnserDetails,
  setQuestion,
  setAnswer,
  setQuestionDetails,
  setCoinDetail
} = userSlice.actions;

// Export the reducer to include in the store
export default userSlice.reducer;
